import React, { Component } from "react"
import TimeEntries from "./layout/time_entries"
import { getCustomer } from "../api/client"

class AdminDashboard extends Component {
    constructor(props) {
        super(props)
    }

    onClickGetCustomer = accountId => {
        getCustomer(accountId)
    }

    render() {
        const {
            handleRangeSelect,
            title,
            onClickBackward,
            onClickForward,
            defaultSelectedOption,
            totalHrs,
            renderButtonBar,
            showByUser,
            userId,
            timeEntries,
            timeEntriesArray,
            timeEntryRollups,
            tags,
            increment,
            createTimeEntry,
            updateTimeEntry,
            teams,
            editTimeEntry,
            isCollapsed,
            runningEntries,
            viewport,
            users,
            selectedTeamMembership,
            trialEnd,
        } = this.props

        return (
            <div className="admin-dash-body-time-entries">
                <TimeEntries
                    handleRangeSelect={handleRangeSelect}
                    title={title}
                    onClickBackward={onClickBackward}
                    onClickForward={onClickForward}
                    defaultSelectedOption={defaultSelectedOption}
                    totalHrs={totalHrs}
                    renderButtonBar={renderButtonBar}
                    userId={userId}
                    timeEntriesArray={timeEntriesArray}
                    timeEntries={timeEntries}
                    timeEntryRollups={timeEntryRollups}
                    tags={tags}
                    increment={increment}
                    createTimeEntry={createTimeEntry}
                    updateTimeEntry={updateTimeEntry}
                    teams={teams}
                    editTimeEntry={editTimeEntry}
                    isCollapsed={isCollapsed}
                    showByUser={showByUser}
                    runningEntries={runningEntries}
                    viewport={viewport}
                    users={users}
                    selectedTeamMembership={selectedTeamMembership}
                    trialEnd={trialEnd}
                />
            </div>
        )
    }
}

export default AdminDashboard



// WEBPACK FOOTER //
// ./src/components/admin_dashboard.jsx